// eslint-disable-next-line
import React, { useState, useEffect } from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import queryString from "query-string";
import { history } from "../../_redux/_store/history";
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { Paper} from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import { useDispatch, useSelector } from 'react-redux'
import {
  getRecommendation,
  deleteRecommendation,
  clearRecommendationState,
} from '../../_redux/_actions/recommendationListActions'

const useStyles = makeStyles(() => ({
  Button: {
    width: '120px',
    marginRight: '20px',
    '&:hover': {
      background: '#52A1C2',
    },
  },
  heading: {
    marginBottom: '20px',
  },
  paragraph: {
    marginBottom: '20px',
    marginTop: '20px',
  },
}))

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell)

export default function DeleteRecommendationRule({
  open,
  onClose,
  recommendationRuleToDelete,
  handleDeleteSuccess,
}) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const recommendation = useSelector((state) => state.recommendation)
  const [scopedFindings, setScopedFindings] = useState('')
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues

  const deleteRecommendationRule = () => {
    dispatch(
      deleteRecommendation(recommendationRuleToDelete, handleDeleteSuccess,machine_type,hmi_type)
    )
  }

  useEffect(() => {
    dispatch(getRecommendation(recommendationRuleToDelete,machine_type,hmi_type))
    return () => {
      dispatch(clearRecommendationState())
    }
  }, [])

  useEffect(() => {
    if (recommendation.singleRecommendation) {
      setScopedFindings(
        recommendation.singleRecommendation.prioritizedSuggestions
      )
    }
  }, [recommendation.singleRecommendation])

  return (
    
      recommendation.singleRecommendation && (
        <Dialog
          open={open}
          onClose={onClose}
          maxWidth={'md'}
          PaperProps={
            scopedFindings.length > 0
              ? { style: { width: '60em', height: '30em', paddingTop: '32px' } }
              : { style: { width: '30em', height: '20em', paddingTop: '32px' } }
          }
        >
          <DialogContent >
            <Grid container direction='column' justifyContent='center'>
              <Grid item container justifyContent='space-between'>
                <Grid item>
                  <Typography style={{ color: 'Red', fontWeight: 1000 }}>
                    Attention
                  </Typography>
                </Grid>
                <Grid item>
                  <Button onClick={onClose}>
                    <CancelIcon style={{ color: '#666666' }} />
                  </Button>
                </Grid>
              </Grid>
              {scopedFindings.length > 0 ? (
                <Grid item className={classes.paragraph}>
                  <p>
                    Deleting this Recommendation will also affect the following
                    Scoped Findings:
                  </p>
                </Grid>
              ) : (
                <Grid item className={classes.paragraph}>
                  <p>Are you sure you want to delete this Recommendation?</p>
                </Grid>
              )}
              {scopedFindings.length > 0 && (
                <Grid item>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableRow fullwidth style={{ backgroundColor: 'grey' }}>
                        <StyledTableCell>
                          <Typography style={{ color: 'white' }}>
                            Scope
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell align='left'>
                          <Typography style={{ color: 'white' }}>
                            Note Text
                          </Typography>
                        </StyledTableCell>
                      </TableRow>
                      <TableBody fullwidth style={{ overflowY: 'scroll' }}>
                        {scopedFindings &&
                          scopedFindings.map((finding) => {
                            return (
                              <TableRow
                                key={
                                  finding.scoped_finding_rule_finding_rule_id
                                }
                                style={{ height: 10 }}
                              >
                                <TableCell scope='row'>
                                  {finding.scopedFindingRule.scope}
                                </TableCell>
                                <TableCell scope='row'>
                                  {finding.scopedFindingRule.note_text}
                                </TableCell>
                              </TableRow>
                            )
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )}
              <Grid container direction='row' style={{ marginTop: '10px' }}>
                <Grid item>
                  <Button
                    variant='outlined'
                    className={classes.Button}
                    onClick={() => deleteRecommendationRule()}
                  >
                    CONFIRM
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant='outlined'
                    className='btn-white'
                    onClick={onClose}
                  >
                    CANCEL
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      )
  )
}

